<template>
	<div class="content-page">
		<div class="content-nav">
			<el-breadcrumb class="breadcrumb" separator="/">
				<el-breadcrumb-item>用户列表</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="content-main">
			<div class="filter-box">
				<el-form :inline="true" :model="filterForm" class="demo-form-inline">
					<el-form-item label="公司名称">
						<el-input v-model="filterForm.company" placeholder="公司名称"></el-input>
					</el-form-item>
					<el-form-item label="用户状态">
						<el-select v-model="filterForm.audited" placeholder="请选择状态">
							<el-option label="全部用户" value=""></el-option>
							<el-option label="已审核用户" value="1"></el-option>
							<el-option label="未审核用户" value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmitFilter">查询</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="form-table-box">
				<el-table :data="tableData" style="width: 100%" border stripe>
					<el-table-column prop="id" label="ID" width="60">
					</el-table-column>
<!--					<el-table-column label="头像" width="80">-->
<!--						<template slot-scope="scope">-->
<!--							<img :src="scope.row.avatar" alt="" style="width: 50px;height: 50px">-->
<!--						</template>-->
<!--					</el-table-column>-->
					<!--<el-table-column prop="username" label="会员名称">-->
					<!--</el-table-column>-->
					<el-table-column prop="nickname" label="昵称">
						<template slot-scope="scope">
							<el-input v-model="scope.row.nickname" placeholder="昵称" @blur="submitNick(scope.$index, scope.row)"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="姓名">
						<template slot-scope="scope">
							<el-input v-model="scope.row.name" placeholder="姓名" @blur="submitNick(scope.$index, scope.row)"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="gender" label="性别" width="120">
						<template slot-scope="scope">
							{{ scope.row.gender == 2 ? '女' : '男' }}
						</template>
					</el-table-column>
          <el-table-column prop="company" label="公司名称" width="300">
          </el-table-column>
          <el-table-column prop="address" label="公司地址" width="350">
          </el-table-column>
					<!--<el-table-column prop="mobile" label="手机号"></el-table-column>-->
					<!--<el-table-column prop="register_time" label="注册时间" width="150">
					</el-table-column>-->
					<el-table-column prop="last_login_time" label="最近登录" width="180">
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button v-if="scope.row.audited === 0" size="small" @click="handleAuditedUser(scope.$index, scope.row)">审核</el-button>
              <el-button v-else size="small" @click="handleAuditedUser(scope.$index, scope.row)">禁用</el-button>
							<!-- <el-button plain size="small" type="danger" @click="handleRowDelete(scope.$index, scope.row)">删除</el-button> -->
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="page-box">
				<el-pagination background @current-change="handlePageChange" :current-page.sync="page" :page-size="10" layout="total, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</div>
    <el-dialog :visible.sync="confirmDialogVisible" title="确认操作">
      <span>您确定要{{ currentRow && currentRow.audited === 0 ? '审核通过' : '禁用' }}该用户吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAudit">取消</el-button>
        <el-button type="primary" @click="confirmAudit">确认</el-button>
      </span>
    </el-dialog>
	</div>
</template>

<script>

import row from "element-ui/packages/row";

export default {
  computed: {
    row() {
      return row
    }
  },
	data() {
		return {
			page: 1,
			total: 0,
      confirmDialogVisible: false,
      currentRow: null,
      currentRowIndex: null,
			filterForm: {
        company: '',
        audited: ''
			},
			tableData: [],
            loginInfo:null,
            username:''
		}
	},
	methods: {
        submitNick(index, row){
            this.axios.post('user/updateInfo', { id: row.id,nickname:row.nickname }).then((response) => {

            })
		},
		handlePageChange(val) {
			this.page = val;
			//保存到localStorage
			localStorage.setItem('userPage', this.page)
			this.getList()
		},
		// handleRowEdit(index, row) {
		// 	this.$router.push({ name: 'user_add', query: { id: row.id } })
		// },
		handleRowEdit(index, row) {
			let prompt = '';
			if (this.filterForm.audited) {
				prompt = '确定要解除该用户权限?';
			} else {
				prompt = '确定要审核该用户权限?';
			}
			this.$confirm(prompt, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.axios.post('user/examine', { id: row.id }).then((response) => {
					console.log(response.data)
					if (response.data.errno === 0 && this.filterForm.audited) {
						this.$message({
							type: 'success',
							message: '解除成功!'
						});
						this.getList();
					} else if (response.data.errno === 0 && !this.filterForm.audited) {
						this.$message({
							type: 'success',
							message: '审核成功!'
						});
						this.getList();
					}
				})
			})
		},
    cancelAudit() {
      this.confirmDialogVisible = false;
      this.currentRow = null;
      this.currentRowIndex = null;
    },
    handleAuditedUser(index, row) {
      this.confirmDialogVisible = true;
      this.currentRow = row;
      this.currentRowIndex = index;
    },
    confirmAudit() {
      this.axios.post('user/audit', { id: this.currentRow.id, audit: 1 - this.currentRow.audited }).then((response) => {
        if (response.data.errno === 0) {
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
          this.getList();
        }
        this.confirmDialogVisible = false;
      })
    },
		handleRowDelete(index, row) {

			this.$confirm('确定要删除?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {

				this.axios.post('user/destory', { id: row.id }).then((response) => {
					console.log(response.data)
					if (response.data.errno === 0) {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});

						this.getList();
					}
				})


			});
		},
		onSubmitFilter() {
			this.page = 1
			this.getList()
		},
		getList() {
			this.axios.get('user', {
				params: {
					page: this.page,
          company: this.filterForm.company,
					audited: this.filterForm.audited ? this.filterForm.audited : null
				}
			}).then((response) => {
                console.log(response.data);
                console.log(response);
                this.tableData = response.data.data.userData.data;
                this.page = response.data.data.userData.currentPage;
                this.total = response.data.data.userData.count;
			})
            if(!this.loginInfo){
                this.loginInfo = JSON.parse(window.localStorage.getItem('userInfo') || null);
                this.username = this.loginInfo.username;
            }
		}
	},
	components: {

	},
	mounted() {
		let thePage = localStorage.getItem('userPage');
        if(thePage == null){
            thePage = 1;
        }
		this.page = Number(thePage);
        console.log(this.page);
		this.getList();
	}
}

</script>

<style scoped>

</style>
